import {Logger} from "../../domain/logger.interface";

export class ConsoleLogger implements Logger {

  debug(message: string, context?: unknown): void {
    console.debug(message, context);
  }

  info(message: string, context?: unknown): void {
    console.info(message, context);
  }

  warn(message: string, error?: unknown, context?: unknown): void {
    console.warn(message, error, context);
  }

  error(message: string, error?: unknown, context?: unknown): void {
    console.error(message, error, context);
  }
}
